import { AnyAppEvent, AppEvent } from "../../appEvent.types";

const eventName = "buy-products" as const;

export type BuyProductAsVisitorEventData = {
  orderId: string;
};

export type BuyProductAsVisitorEvent = AppEvent<
  typeof eventName,
  BuyProductAsVisitorEventData
>;

export const isBuyProductAsVisitorEvent = (
  event: AnyAppEvent
): event is BuyProductAsVisitorEvent => event.name === eventName;

export { eventName as buyProductAsVisitor };
